import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type Locale = "en" | "ar";

interface LanguageState {
  locale: Locale;
}

// Read persisted preference from localStorage safely
const getInitialLocale = (): Locale => {
  try {
    const saved = localStorage.getItem("drpaw_lang");
    return saved === "ar" ? "ar" : "en";
  } catch {
    return "en";
  }
};

const languageSlice = createSlice({
  name: "language",
  initialState: { locale: getInitialLocale() } as LanguageState,
  reducers: {
    switchLanguage(state, action: PayloadAction<Locale>) {
      state.locale = action.payload;
      try {
        localStorage.setItem("drpaw_lang", action.payload);
      } catch {}
    },
  },
});

export const { switchLanguage } = languageSlice.actions;
export default languageSlice.reducer;
